<template>
  <div>
    <!-- Overlay -->
    <div
      v-if="visible"
      class="sidebar-overlay"
      @click="$emit('close')"
    />

    <!-- Sidebar -->
    <div
      class="tareas-sidebar"
      :class="{ 'sidebar-open': visible }"
    >
      <!-- Header -->
      <div class="sidebar-header">
        <h5 class="mb-0">
          <i class="fa-solid fa-list-check mr-1"></i>
          Tareas
        </h5>
        <div class="d-flex align-items-center">
          <!-- Aviso por email el día antes del vencimiento -->
          <button
            class="toggle-completadas mr-1"
            :class="{ 'is-active': avisoEmail }"
            :title="avisoEmail ? 'Recibes un email el día antes de que venza cada tarea' : 'Activar email recordatorio el día antes del vencimiento'"
            @click="toggleAvisoEmail"
          >
            <i :class="avisoEmail ? 'fa-solid fa-bell' : 'fa-regular fa-bell-slash'"></i>
            Avisos
          </button>
          <!-- Toggle mostrar completadas -->
          <button
            class="toggle-completadas mr-1"
            :class="{ 'is-active': mostrarCompletadas }"
            @click="mostrarCompletadas = !mostrarCompletadas; recargarTodosLosBloques()"
          >
            <i class="fa-solid fa-check-double"></i>
            Completadas
          </button>
          <button
            class="btn btn-link p-0 text-dark"
            @click="$emit('close')"
          >
            <i class="fa-solid fa-times"></i>
          </button>
        </div>
      </div>

      <!-- Lista de bloques (acordeón) -->
      <div class="bloques-lista">
        <div v-if="cargandoBloques" class="text-center py-4">
          <i class="fa-solid fa-spinner fa-spin fa-2x text-muted"></i>
        </div>

        <div v-else>
          <div
            v-for="bloque in bloques"
            :key="bloque.id"
            class="bloque-acordeon"
          >
            <!-- Header del bloque -->
            <div
              class="bloque-header"
              :class="{ 'bloque-activo': esBloqueAbierto(bloque.id) }"
              @click="toggleBloque(bloque)"
            >
              <div class="d-flex align-items-center flex-grow-1">
                <i
                  class="fa-solid mr-2"
                  :class="esBloqueAbierto(bloque.id) ? 'fa-chevron-down' : 'fa-chevron-right'"
                ></i>
                <i
                  v-if="bloque.tipo === 'privado'"
                  class="fa-solid fa-lock text-muted mr-2"
                ></i>
                <span
                  v-else
                  class="bloque-color mr-2"
                  :style="{ backgroundColor: bloque.color }"
                ></span>
                <span class="bloque-nombre">{{ bloque.nombre }}</span>
                <b-badge
                  v-if="bloque.pendientes > 0"
                  variant="primary"
                  pill
                  class="ml-2"
                >
                  {{ bloque.pendientes }}
                </b-badge>
              </div>
              <b-button
                v-if="bloque.tipo !== 'privado'"
                variant="link"
                size="sm"
                class="p-0 mr-1"
                @click.stop="abrirModalMiembrosBloque(bloque)"
                v-b-tooltip.hover
                title="Miembros"
              >
                <i class="fa-solid fa-users text-muted"></i>
              </b-button>
            </div>

            <!-- Contenido del bloque (tareas) -->
            <b-collapse :visible="esBloqueAbierto(bloque.id)">
              <div class="bloque-contenido">
                <!-- Input nueva tarea -->
                <div class="nueva-tarea-input mb-2">
                  <b-input-group size="sm">
                    <b-form-input
                      v-model="nuevaTareasPorBloque[bloque.id]"
                      placeholder="Nueva tarea..."
                      @keyup.enter="crearTareaEnBloque(bloque.id)"
                    />
                    <b-input-group-append>
                      <b-button
                        variant="primary"
                        :disabled="!nuevaTareasPorBloque[bloque.id] || !nuevaTareasPorBloque[bloque.id].trim() || creando"
                        @click="crearTareaEnBloque(bloque.id)"
                      >
                        <i v-if="creando" class="fa-solid fa-spinner fa-spin"></i>
                        <i v-else class="fa-solid fa-plus"></i>
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>
                </div>

                <!-- Lista de tareas del bloque -->
                <div v-if="cargandoTareas[bloque.id]" class="text-center py-3">
                  <i class="fa-solid fa-spinner fa-spin text-muted"></i>
                </div>

                <div v-else-if="!tareasPorBloque[bloque.id] || tareasPorBloque[bloque.id].length === 0" class="text-center py-3 text-muted">
                  <small>Sin tareas pendientes</small>
                </div>

                <div v-else>
                  <div
                    v-for="tarea in tareasPorBloque[bloque.id]"
                    :key="tarea.id"
                    class="tarea-item"
                    :class="{
                      'tarea-completada': tarea.completada,
                      'tarea-asignada-ami': tarea.id_responsable === usuarioActualId,
                      'tarea-expandida': tareaExpandida === tarea.id
                    }"
                    @click="toggleDescripcion(tarea)"
                  >
                    <div class="d-flex align-items-start">
                      <b-form-checkbox
                        :checked="tarea.completada === 1"
                        class="mr-2 mt-1"
                        @change="toggleTarea(tarea, bloque.id)"
                        @click.native.stop
                      />
                      <div class="flex-grow-1">
                        <div
                          class="tarea-titulo"
                          :class="{ 'text-decoration-line-through text-muted': tarea.completada }"
                        >
                          {{ tarea.titulo }}
                        </div>
                        <div v-if="tareaExpandida === tarea.id && tarea.descripcion" class="tarea-descripcion mt-1">
                          {{ tarea.descripcion }}
                        </div>
                        <div class="tarea-meta">
                          <span v-if="tarea.prioridad === 'alta'" class="tchip tchip--danger">
                            <i class="fa-solid fa-flag"></i> Alta
                          </span>
                          <span
                            v-if="tarea.fecha_vencimiento"
                            class="tchip"
                            :class="esFechaVencida(tarea.fecha_vencimiento) ? 'tchip--danger' : 'tchip--info'"
                          >
                            <i class="fa-solid fa-calendar-day"></i> {{ formatearFecha(tarea.fecha_vencimiento) }}
                          </span>
                          <span v-if="tarea.responsable_nombre" class="tchip tchip--user">
                            <i class="fa-solid fa-user"></i> {{ tarea.responsable_nombre }}
                          </span>
                          <span class="tarea-meta__time">
                            <i v-if="tarea.descripcion" class="fa-solid fa-align-left mr-50"></i>
                            {{ tiempoTranscurrido(tarea.fecha_creacion) }}
                          </span>
                        </div>
                      </div>
                      <b-dropdown
                        variant="link"
                        toggle-class="text-decoration-none p-0"
                        no-caret
                        right
                        @click.native.stop
                      >
                        <template #button-content>
                          <i class="fa-solid fa-ellipsis-v text-muted"></i>
                        </template>
                        <b-dropdown-item @click="editarTarea(tarea, bloque.id)">
                          <i class="fa-solid fa-edit mr-1"></i> Editar
                        </b-dropdown-item>
                        <b-dropdown-item
                          variant="danger"
                          @click="confirmarEliminar(tarea, bloque.id)"
                        >
                          <i class="fa-solid fa-trash mr-1"></i> Eliminar
                        </b-dropdown-item>
                      </b-dropdown>
                    </div>
                  </div>
                </div>
              </div>
            </b-collapse>
          </div>
        </div>
      </div>

      <!-- Footer con botón nuevo bloque -->
      <div class="sidebar-footer">
        <b-button
          variant="outline-secondary"
          size="sm"
          block
          @click="mostrarModalBloque = true"
        >
          <i class="fa-solid fa-folder-plus mr-1"></i>
          Nuevo bloque
        </b-button>
      </div>
    </div>

    <!-- Modal crear bloque -->
    <b-modal
      v-model="mostrarModalBloque"
      title="Nuevo Bloque"
      @ok="crearBloque"
      :ok-disabled="!nuevoBloque.nombre.trim()"
      ok-title="Crear"
      cancel-title="Cancelar"
    >
      <b-form-group label="Nombre" label-for="bloque-nombre">
        <b-form-input
          id="bloque-nombre"
          v-model="nuevoBloque.nombre"
          placeholder="Nombre del bloque"
        />
      </b-form-group>
      <b-form-group label="Color" label-for="bloque-color">
        <b-form-input
          id="bloque-color"
          v-model="nuevoBloque.color"
          type="color"
          class="form-control-color"
        />
      </b-form-group>
    </b-modal>

    <!-- Modal editar tarea -->
    <b-modal
      v-model="mostrarModalEditar"
      title="Editar Tarea"
      @ok="guardarEdicion"
      :ok-disabled="!tareaEditando.titulo || !tareaEditando.titulo.trim()"
      ok-title="Guardar"
      cancel-title="Cancelar"
    >
      <b-form-group label="Titulo" label-for="tarea-titulo">
        <b-form-input
          id="tarea-titulo"
          v-model="tareaEditando.titulo"
          placeholder="Titulo de la tarea"
        />
      </b-form-group>
      <b-form-group label="Descripcion" label-for="tarea-descripcion">
        <b-form-textarea
          id="tarea-descripcion"
          v-model="tareaEditando.descripcion"
          placeholder="Descripcion (opcional)"
          rows="12"
        />
      </b-form-group>
      <b-row>
        <b-col cols="6">
          <b-form-group label="Prioridad" label-for="tarea-prioridad">
            <b-form-select
              id="tarea-prioridad"
              v-model="tareaEditando.prioridad"
              :options="prioridadOptions"
            />
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group label="Fecha limite" label-for="tarea-fecha">
            <b-form-input
              id="tarea-fecha"
              v-model="tareaEditando.fecha_vencimiento"
              type="date"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-form-group label="Asignar a" label-for="tarea-responsable">
        <b-form-select
          id="tarea-responsable"
          v-model="tareaEditando.id_responsable"
          :options="miembrosOptions"
        />
      </b-form-group>
    </b-modal>

    <!-- Modal gestionar miembros -->
    <b-modal
      v-model="mostrarModalMiembros"
      :title="`Miembros de ${bloqueActual ? bloqueActual.nombre : ''}`"
      size="md"
    >
      <template #modal-footer="{ close }">
        <b-button
          v-if="bloqueActual && bloqueActual.mi_rol === 'propietario' && bloqueActual.tipo !== 'privado'"
          variant="outline-danger"
          class="mr-auto"
          @click="eliminarBloque"
        >
          <i class="fa-solid fa-trash mr-50"></i> Eliminar bloque
        </b-button>
        <b-button variant="primary" @click="close()">Cerrar</b-button>
      </template>
      <!-- Buscar y agregar usuario -->
      <b-form-group label="Invitar usuario" label-for="buscar-usuario">
        <b-input-group size="sm">
          <b-form-input
            id="buscar-usuario"
            v-model="busquedaUsuario"
            placeholder="Filtrar por nombre o email..."
          />
        </b-input-group>

        <!-- Listado de usuarios -->
        <div v-if="usuariosFiltrados.length > 0" class="lista-usuarios-busqueda mt-2" style="max-height: 250px; overflow-y: auto;">
          <div
            v-for="usuario in usuariosFiltrados"
            :key="usuario.id"
            class="usuario-busqueda-item d-flex justify-content-between align-items-center"
          >
            <div>
              <strong>{{ usuario.nombre }}</strong>
              <br>
              <small class="text-muted">{{ usuario.email }}</small>
            </div>
            <b-button
              v-if="!esMiembro(usuario.id)"
              variant="outline-primary"
              size="sm"
              @click="agregarMiembro(usuario)"
            >
              <i class="fa-solid fa-plus"></i>
            </b-button>
            <b-badge v-else variant="light-secondary" pill>
              Ya miembro
            </b-badge>
          </div>
        </div>
        <div v-else-if="todosUsuarios.length === 0" class="text-muted small mt-1">
          Cargando usuarios...
        </div>
      </b-form-group>

      <hr>

      <!-- Lista de miembros actuales -->
      <h6>Miembros actuales</h6>
      <div v-if="cargandoMiembros" class="text-center py-3">
        <i class="fa-solid fa-spinner fa-spin"></i>
      </div>
      <div v-else-if="miembros.length === 0" class="text-muted small">
        No hay miembros
      </div>
      <div v-else class="lista-miembros">
        <div
          v-for="miembro in miembros"
          :key="miembro.id"
          class="miembro-item d-flex justify-content-between align-items-center"
        >
          <div>
            <strong>{{ miembro.usuario_nombre }}</strong>
            <b-badge
              :variant="rolVariant(miembro.rol)"
              class="ml-2"
              pill
            >
              {{ miembro.rol }}
            </b-badge>
            <br>
            <small class="text-muted">{{ miembro.usuario_email }}</small>
          </div>
          <b-button
            v-if="miembro.rol !== 'propietario' && bloqueActual && bloqueActual.mi_rol === 'propietario'"
            variant="outline-danger"
            size="sm"
            @click="quitarMiembro(miembro)"
          >
            <i class="fa-solid fa-times"></i>
          </b-button>
        </div>
      </div>
    </b-modal>

    <!-- Modal confirmar eliminar -->
    <b-modal
      v-model="mostrarModalEliminar"
      title="Eliminar tarea"
      ok-variant="danger"
      ok-title="Eliminar"
      cancel-title="Cancelar"
      @ok="eliminarTarea"
      centered
      size="sm"
    >
      <div class="text-center">
        <i class="fa-solid fa-trash-can text-danger mb-3" style="font-size: 2.5rem"></i>
        <p class="mb-0">¿Eliminar esta tarea?</p>
        <p class="text-muted small" v-if="tareaEliminar">{{ tareaEliminar.titulo }}</p>
      </div>
    </b-modal>
  </div>
</template>

<script>
import {
  BFormInput,
  BInputGroup,
  BInputGroupAppend,
  BButton,
  BFormCheckbox,
  BBadge,
  BDropdown,
  BDropdownItem,
  BModal,
  BFormGroup,
  BFormTextarea,
  BFormSelect,
  BRow,
  BCol,
  BCollapse,
  VBTooltip
} from 'bootstrap-vue'
import axios from '@axios'

export default {
  name: 'TareasSidebar',
  components: {
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
    BButton,
    BFormCheckbox,
    BBadge,
    BDropdown,
    BDropdownItem,
    BModal,
    BFormGroup,
    BFormTextarea,
    BFormSelect,
    BRow,
    BCol,
    BCollapse
  },
  directives: {
    'b-tooltip': VBTooltip
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      bloques: [],
      bloquesAbiertos: [],
      tareasPorBloque: {},
      cargandoTareas: {},
      nuevaTareasPorBloque: {},
      mostrarCompletadas: false,
      avisoEmail: false,
      cargandoBloques: false,
      creando: false,
      mostrarModalBloque: false,
      mostrarModalEditar: false,
      bloqueEditandoId: null,
      nuevoBloque: {
        nombre: '',
        color: '#3788d8'
      },
      tareaEditando: {
        id: null,
        titulo: '',
        descripcion: '',
        prioridad: 'media',
        fecha_vencimiento: null,
        id_responsable: null
      },
      prioridadOptions: [
        { value: 'baja', text: 'Baja' },
        { value: 'media', text: 'Media' },
        { value: 'alta', text: 'Alta' }
      ],
      mostrarModalMiembros: false,
      miembros: [],
      cargandoMiembros: false,
      busquedaUsuario: '',
      todosUsuarios: [],
      timeoutBusqueda: null,
      mostrarModalEliminar: false,
      tareaEliminar: null,
      bloqueEliminarId: null,
      tareaExpandida: null
    }
  },
  computed: {
    usuarioActualId() {
      const userData = JSON.parse(localStorage.getItem('userData'))
      return userData ? userData.id : null
    },
    bloquesOptions() {
      return this.bloques.map(b => ({
        value: b.id,
        text: `${b.tipo === 'privado' ? '🔒 ' : ''}${b.nombre} (${b.pendientes || 0})`
      }))
    },
    bloqueActual() {
      return this.bloques.find(b => b.id === this.bloqueEditandoId)
    },
    miembrosOptions() {
      const options = [{ value: null, text: 'Sin asignar' }]
      this.miembros.forEach(m => {
        options.push({ value: m.id_usuario, text: m.usuario_nombre })
      })
      return options
    },
    usuariosFiltrados() {
      if (!this.busquedaUsuario || this.busquedaUsuario.trim() === '') {
        return this.todosUsuarios
      }
      const q = this.busquedaUsuario.toLowerCase()
      return this.todosUsuarios.filter(u =>
        (u.nombre && u.nombre.toLowerCase().includes(q)) ||
        (u.email && u.email.toLowerCase().includes(q))
      )
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.inicializar()
      }
    }
  },
  methods: {
    toggleDescripcion(tarea) {
      this.tareaExpandida = this.tareaExpandida === tarea.id ? null : tarea.id
    },

    async inicializar() {
      await this.initBloquePrivado()
      await this.cargarBloques()
      this.cargarAvisoEmail()
    },

    async cargarAvisoEmail() {
      try {
        const { data } = await axios.get('/tareas/aviso-email')
        this.avisoEmail = data.activo
      } catch (err) {
        console.error('Error al cargar aviso email:', err)
      }
    },

    async toggleAvisoEmail() {
      try {
        const { data } = await axios.put('/tareas/aviso-email', { activo: !this.avisoEmail })
        this.avisoEmail = data.activo
      } catch (err) {
        console.error('Error al guardar aviso email:', err)
      }
    },

    async initBloquePrivado() {
      try {
        await axios.post('/tareas/init')
      } catch (err) {
        console.error('Error al inicializar bloque privado:', err)
      }
    },

    async cargarBloques() {
      this.cargandoBloques = true
      try {
        const response = await axios.get('/tareas/bloques')
        this.bloques = response.data

        // Abrir automáticamente bloques con tareas pendientes
        if (this.bloquesAbiertos.length === 0) {
          const bloquesConPendientes = this.bloques.filter(b => b.pendientes > 0)

          if (bloquesConPendientes.length > 0) {
            // Abrir todos los que tienen pendientes
            for (const bloque of bloquesConPendientes) {
              this.bloquesAbiertos.push(bloque.id)
              await this.cargarTareasBloque(bloque.id)
            }
          } else if (this.bloques.length > 0) {
            // Si ninguno tiene pendientes, abrir el primero
            this.bloquesAbiertos.push(this.bloques[0].id)
            await this.cargarTareasBloque(this.bloques[0].id)
          }
        }
      } catch (err) {
        console.error('Error al cargar bloques:', err)
      } finally {
        this.cargandoBloques = false
      }
    },

    async toggleBloque(bloque) {
      const index = this.bloquesAbiertos.indexOf(bloque.id)
      if (index > -1) {
        // Cerrar el bloque
        this.bloquesAbiertos.splice(index, 1)
      } else {
        // Abrir el bloque
        this.bloquesAbiertos.push(bloque.id)
        if (!this.tareasPorBloque[bloque.id]) {
          await this.cargarTareasBloque(bloque.id)
        }
      }
    },

    esBloqueAbierto(bloqueId) {
      return this.bloquesAbiertos.includes(bloqueId)
    },

    async cargarTareasBloque(bloqueId) {
      this.$set(this.cargandoTareas, bloqueId, true)
      try {
        const response = await axios.get(`/tareas/bloques/${bloqueId}/items`, {
          params: { mostrar_completadas: this.mostrarCompletadas }
        })
        this.$set(this.tareasPorBloque, bloqueId, response.data)
      } catch (err) {
        console.error('Error al cargar tareas:', err)
      } finally {
        this.$set(this.cargandoTareas, bloqueId, false)
      }
    },

    async recargarTodosLosBloques() {
      // Recargar tareas de todos los bloques que ya están cargados
      for (const bloqueId of Object.keys(this.tareasPorBloque)) {
        await this.cargarTareasBloque(parseInt(bloqueId))
      }
      await this.cargarBloques()
    },

    async crearTareaEnBloque(bloqueId) {
      const titulo = this.nuevaTareasPorBloque[bloqueId]
      if (!titulo || !titulo.trim()) return

      this.creando = true
      try {
        await axios.post(`/tareas/bloques/${bloqueId}/items`, {
          titulo: titulo.trim()
        })
        this.$set(this.nuevaTareasPorBloque, bloqueId, '')
        await this.cargarTareasBloque(bloqueId)
        await this.cargarBloques()
        this.$emit('actualizado')
      } catch (err) {
        console.error('Error al crear tarea:', err)
        this.$bvToast.toast('Error al crear tarea', {
          title: 'Error',
          variant: 'danger',
          solid: true
        })
      } finally {
        this.creando = false
      }
    },

    async toggleTarea(tarea, bloqueId) {
      try {
        await axios.put(`/tareas/items/${tarea.id}/toggle`)
        await this.cargarTareasBloque(bloqueId)
        await this.cargarBloques()
        this.$emit('actualizado')
      } catch (err) {
        console.error('Error al cambiar estado:', err)
      }
    },

    async editarTarea(tarea, bloqueId) {
      this.bloqueEditandoId = bloqueId
      // Cargar miembros del bloque para el selector
      await this.cargarMiembrosBloque(bloqueId)

      this.tareaEditando = {
        id: tarea.id,
        titulo: tarea.titulo,
        descripcion: tarea.descripcion || '',
        prioridad: tarea.prioridad,
        fecha_vencimiento: tarea.fecha_vencimiento ? tarea.fecha_vencimiento.slice(0, 10) : null, // vale para 'YYYY-MM-DD HH:mm:ss' e ISO
        id_responsable: tarea.id_responsable || null
      }
      this.mostrarModalEditar = true
    },

    async guardarEdicion() {
      try {
        await axios.put(`/tareas/items/${this.tareaEditando.id}`, {
          titulo: this.tareaEditando.titulo,
          descripcion: this.tareaEditando.descripcion,
          prioridad: this.tareaEditando.prioridad,
          fecha_vencimiento: this.tareaEditando.fecha_vencimiento || null,
          id_responsable: this.tareaEditando.id_responsable || null
        })
        if (this.bloqueEditandoId) {
          await this.cargarTareasBloque(this.bloqueEditandoId)
        }
        this.mostrarModalEditar = false
      } catch (err) {
        console.error('Error al guardar tarea:', err)
      }
    },

    confirmarEliminar(tarea, bloqueId) {
      this.tareaEliminar = tarea
      this.bloqueEliminarId = bloqueId
      this.mostrarModalEliminar = true
    },

    async eliminarTarea() {
      if (!this.tareaEliminar) return

      try {
        await axios.delete(`/tareas/items/${this.tareaEliminar.id}`)
        if (this.bloqueEliminarId) {
          await this.cargarTareasBloque(this.bloqueEliminarId)
        }
        await this.cargarBloques()
        this.$emit('actualizado')
        this.tareaEliminar = null
        this.bloqueEliminarId = null
      } catch (err) {
        console.error('Error al eliminar tarea:', err)
      }
    },

    async crearBloque() {
      if (!this.nuevoBloque.nombre.trim()) return

      try {
        const response = await axios.post('/tareas/bloques', {
          nombre: this.nuevoBloque.nombre,
          color: this.nuevoBloque.color
        })
        await this.cargarBloques()
        const nuevoId = response.data.bloque.id
        if (!this.bloquesAbiertos.includes(nuevoId)) {
          this.bloquesAbiertos.push(nuevoId)
        }
        await this.cargarTareasBloque(nuevoId)
        this.nuevoBloque = { nombre: '', color: '#3788d8' }
        this.mostrarModalBloque = false
      } catch (err) {
        console.error('Error al crear bloque:', err)
      }
    },

    tiempoTranscurrido(fecha) {
      if (!fecha) return ''

      const ahora = new Date()
      const creacion = new Date(fecha)
      const diff = ahora - creacion
      const minutos = Math.floor(diff / 60000)
      const horas = Math.floor(minutos / 60)
      const dias = Math.floor(horas / 24)

      if (dias > 0) return `hace ${dias}d`
      if (horas > 0) return `hace ${horas}h`
      if (minutos > 0) return `hace ${minutos}m`
      return 'ahora'
    },

    formatearFecha(fecha) {
      if (!fecha) return ''
      const date = new Date(fecha)
      return date.toLocaleDateString('es-ES', { day: '2-digit', month: 'short' })
    },

    esFechaVencida(fecha) {
      if (!fecha) return false
      const hoy = new Date()
      hoy.setHours(0, 0, 0, 0)
      const fechaVenc = new Date(fecha)
      fechaVenc.setHours(0, 0, 0, 0)
      return fechaVenc < hoy
    },

    async abrirModalMiembrosBloque(bloque) {
      this.bloqueEditandoId = bloque.id
      this.mostrarModalMiembros = true
      this.busquedaUsuario = ''
      await Promise.all([
        this.cargarMiembrosBloque(bloque.id),
        this.cargarTodosUsuarios()
      ])
    },

    async cargarTodosUsuarios() {
      if (this.todosUsuarios.length > 0) return
      try {
        const response = await axios.get('/tareas/usuarios')
        this.todosUsuarios = response.data
      } catch (err) {
        console.error('Error al cargar usuarios:', err)
      }
    },

    async cargarMiembrosBloque(bloqueId) {
      this.cargandoMiembros = true
      try {
        const response = await axios.get(`/tareas/bloques/${bloqueId}/miembros`)
        this.miembros = response.data
      } catch (err) {
        console.error('Error al cargar miembros:', err)
      } finally {
        this.cargandoMiembros = false
      }
    },


    esMiembro(usuarioId) {
      return this.miembros.some(m => m.id_usuario === usuarioId)
    },

    async agregarMiembro(usuario) {
      try {
        await axios.post(`/tareas/bloques/${this.bloqueEditandoId}/miembros`, {
          id_usuario: usuario.id,
          rol: 'miembro'
        })
        this.$bvToast.toast(`${usuario.nombre} agregado al bloque`, {
          title: 'Miembro agregado',
          variant: 'success',
          solid: true
        })
        await this.cargarMiembrosBloque(this.bloqueEditandoId)
      } catch (err) {
        console.error('Error al agregar miembro:', err)
        this.$bvToast.toast(err.response?.data?.error || 'Error al agregar miembro', {
          title: 'Error',
          variant: 'danger',
          solid: true
        })
      }
    },

    async eliminarBloque() {
      const bloque = this.bloqueActual
      const ok = await this.$bvModal.msgBoxConfirm(
        `Se eliminará "${bloque.nombre}" con todas sus tareas y miembros. No se puede deshacer.`,
        { title: 'Eliminar bloque', okVariant: 'danger', okTitle: 'Eliminar', cancelTitle: 'Cancelar', centered: true }
      )
      if (!ok) return

      try {
        await axios.delete(`/tareas/bloques/${bloque.id}`)
        this.mostrarModalMiembros = false
        this.bloquesAbiertos = this.bloquesAbiertos.filter(id => id !== bloque.id)
        this.$delete(this.tareasPorBloque, bloque.id)
        await this.cargarBloques()
        this.$emit('actualizado')
        this.$bvToast.toast(`Bloque "${bloque.nombre}" eliminado`, {
          title: 'Bloque eliminado',
          variant: 'success',
          solid: true
        })
      } catch (err) {
        console.error('Error al eliminar bloque:', err)
        this.$bvToast.toast(err.response?.data?.error || 'Error al eliminar bloque', {
          title: 'Error',
          variant: 'danger',
          solid: true
        })
      }
    },

    async quitarMiembro(miembro) {
      if (!confirm(`¿Quitar a ${miembro.usuario_nombre} del bloque?`)) return

      try {
        await axios.delete(`/tareas/bloques/${this.bloqueEditandoId}/miembros/${miembro.id_usuario}`)
        this.$bvToast.toast(`${miembro.usuario_nombre} eliminado del bloque`, {
          title: 'Miembro eliminado',
          variant: 'success',
          solid: true
        })
        await this.cargarMiembrosBloque(this.bloqueEditandoId)
      } catch (err) {
        console.error('Error al quitar miembro:', err)
        this.$bvToast.toast(err.response?.data?.error || 'Error al quitar miembro', {
          title: 'Error',
          variant: 'danger',
          solid: true
        })
      }
    },

    rolVariant(rol) {
      switch (rol) {
        case 'propietario': return 'primary'
        case 'editor': return 'warning'
        default: return 'secondary'
      }
    }
  }
}
</script>

<style scoped>
.sidebar-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  z-index: 1040;
}

.tareas-sidebar {
  position: fixed;
  top: 0;
  right: -380px;
  width: 380px;
  height: 100vh;
  background: #fff;
  box-shadow: -2px 0 10px rgba(0, 0, 0, 0.1);
  z-index: 1050;
  transition: right 0.3s ease;
  display: flex;
  flex-direction: column;
}

.tareas-sidebar.sidebar-open {
  right: 0;
}

.sidebar-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  border-bottom: 1px solid #e9ecef;
}

/* Acordeón de bloques */
.bloques-lista {
  flex: 1;
  overflow-y: auto;
}

.bloque-acordeon {
  border-bottom: 1px solid #e9ecef;
}

.bloque-header {
  display: flex;
  align-items: center;
  padding: 0.75rem 1rem;
  cursor: pointer;
  transition: background 0.2s;
  user-select: none;
}

.bloque-header:hover {
  background: #f8f9fa;
}

.bloque-header.bloque-activo {
  background: #f0f4f8;
}

.bloque-color {
  width: 12px;
  height: 12px;
  border-radius: 3px;
  flex-shrink: 0;
}

.bloque-nombre {
  font-weight: 600;
  font-size: 0.95rem;
  color: #1E293B;
}

.toggle-completadas {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  height: 28px;
  padding: 0 10px;
  border-radius: 999px;
  border: 1px solid #E2E8F0;
  background: #fff;
  color: #64748B;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s;
}

.toggle-completadas:hover {
  border-color: #CBD5E1;
  color: #1E293B;
}

.toggle-completadas.is-active {
  background: #ECFDF5;
  border-color: #A7F3D0;
  color: #059669;
}

.dark-layout .toggle-completadas {
  background: transparent;
  border-color: #3b4253;
  color: #94A3B8;
}

.dark-layout .toggle-completadas.is-active {
  background: rgba(16, 185, 129, 0.15);
  border-color: rgba(16, 185, 129, 0.4);
  color: #34D399;
}

.sidebar-header h5 {
  color: #1E293B;
  font-weight: 600;
}

.tareas-sidebar .text-muted {
  color: #64748B !important;
}

.bloque-contenido {
  padding: 0.5rem 1rem 1rem 1rem;
  background: #fafbfc;
  border-top: 1px solid #e9ecef;
}

.nueva-tarea-input {
  margin-bottom: 0.5rem;
}

.tarea-item {
  padding: 10px 12px;
  background: #fff;
  border-radius: 10px;
  margin-bottom: 8px;
  border: 1px solid #E2E8F0;
  transition: border-color 0.15s, box-shadow 0.15s;
  cursor: pointer;
}

.tarea-item:hover {
  border-color: #CBD5E1;
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.06);
}

.tarea-item:last-child {
  margin-bottom: 0;
}

.tarea-completada {
  opacity: 0.6;
}

.tarea-asignada-ami,
.tarea-asignada-ami:hover {
  border-color: #BFDBFE;
}

/* Meta: chips suaves + tiempo */
.tarea-meta {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 6px;
}

.tchip {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  border-radius: 6px;
  font-size: 11px;
  font-weight: 600;
  line-height: 1.5;
  white-space: nowrap;
}

.tchip i { font-size: 10px; }

.tchip--danger { background: #FEF2F2; color: #DC2626; }
.tchip--info   { background: #EFF6FF; color: #2563EB; }
.tchip--user   { background: #F1F5F9; color: #475569; }

.tarea-meta__time {
  margin-left: auto;
  font-size: 11px;
  color: #94A3B8;
  white-space: nowrap;
}

.tarea-titulo {
  font-size: 0.95rem;
  font-weight: 500;
  color: #1E293B;
  line-height: 1.3;
}

.tarea-descripcion {
  font-size: 0.8rem;
  color: #6e6b7b;
  white-space: pre-wrap;
  padding: 0.4rem 0.5rem;
  background: #f8f9fa;
  border-radius: 4px;
  border-left: 2px solid #7367f0;
}

.tarea-expandida {
  border-color: #7367f0;
}

.sidebar-footer {
  padding: 1rem;
  border-top: 1px solid #e9ecef;
}

/* Dark mode support */
.dark-layout .tareas-sidebar {
  background: #283046;
}

.dark-layout .sidebar-header,
.dark-layout .sidebar-footer,
.dark-layout .bloque-acordeon {
  border-color: #3b4253;
}

.dark-layout .bloque-header:hover {
  background: #3b4253;
}

.dark-layout .bloque-header.bloque-activo {
  background: #3b4253;
}

.dark-layout .bloque-contenido {
  background: #242b3d;
  border-color: #3b4253;
}

.dark-layout .tarea-item {
  background: #283046;
  border-color: #3b4253;
}

.dark-layout .tarea-item:hover {
  border-color: #4b5563;
}

.dark-layout .tarea-descripcion {
  background: #1e2536;
  color: #b4b7bd;
}

.dark-layout .tarea-expandida {
  border-color: #7367f0;
}

.dark-layout .tarea-asignada-ami,
.dark-layout .tarea-asignada-ami:hover {
  border-color: rgba(59, 130, 246, 0.45);
}

.dark-layout .tchip--danger { background: rgba(239, 68, 68, 0.15); color: #F87171; }
.dark-layout .tchip--info   { background: rgba(59, 130, 246, 0.15); color: #60A5FA; }
.dark-layout .tchip--user   { background: rgba(148, 163, 184, 0.15); color: #CBD5E1; }

.dark-layout .sidebar-header button {
  color: #fff !important;
}

.dark-layout .sidebar-header h5,
.dark-layout .bloque-nombre,
.dark-layout .tarea-titulo {
  color: #d0d2d6;
}

.dark-layout .tareas-sidebar .text-muted {
  color: #94A3B8 !important;
}

@media (max-width: 576px) {
  .tareas-sidebar {
    width: 100%;
    right: -100%;
  }
}

/* Lista de usuarios búsqueda */
.lista-usuarios-busqueda {
  max-height: 200px;
  overflow-y: auto;
  border: 1px solid #e9ecef;
  border-radius: 4px;
}

.usuario-busqueda-item {
  padding: 0.5rem 0.75rem;
  border-bottom: 1px solid #f1f1f1;
}

.usuario-busqueda-item:last-child {
  border-bottom: none;
}

.usuario-busqueda-item:hover {
  background: #f8f9fa;
}

/* Lista de miembros */
.lista-miembros {
  max-height: 300px;
  overflow-y: auto;
}

.miembro-item {
  padding: 0.5rem 0;
  border-bottom: 1px solid #f1f1f1;
}

.miembro-item:last-child {
  border-bottom: none;
}

/* Dark mode */
.dark-layout .lista-usuarios-busqueda {
  border-color: #3b4253;
}

.dark-layout .usuario-busqueda-item,
.dark-layout .miembro-item {
  border-color: #3b4253;
}

.dark-layout .usuario-busqueda-item:hover {
  background: #3b4253;
}
</style>
